const DOMPurify = require('dompurify');
const DEFAULT_CONFIG = require('./DEFAULT');

class XssFilter {
  constructor() {
    this.config = DEFAULT_CONFIG;
  }
  
  /**
   * Overrides config object
   * @param {object} config A config object for xss package.
   */
  setConfig(config) {
    this.config = config;
  }

  /**
   * Overrides one property in config object
   * @param {string} name A name of property in config.
   * @param {any} value A property value.
   */
  setConfigProperty(name, value) {
    this.config[name] = value;
  }

  /**
   * Filter html to prevent xss attack
   * @param {string} html A html which need to be filtered
   * @param {object=} config [optional] Property with config of xss package, if
   *      not exist, used config property from class. 
   */
  filter(html, config = this.config) {
    return DOMPurify.sanitize(html, config);
  } 
}

module.exports = new XssFilter();
